import styled, { css } from 'styled-components';

const OnboardingWrapper = styled.div(
  ({ theme: { images } }) => css`
    background: var(--color-fg-default);
    background-image: url('${images.rocketOnboarding}');
    background-position: 21% 17.5%;
    background-repeat: no-repeat;
    border-radius: var(--size-border-radius-circle); //
    bottom: -455px;
    box-shadow: var(--shadow-m);
    height: 900px;
    left: -137px;
    position: fixed;
    width: 900px;
    z-index: 11000;
  `
);

const RocketBody = styled.div`
  color: var(--color-fg-inverse-default);
  left: 25%;
  margin-left: 90px;
  position: absolute;
  right: 18%;
  top: 20%;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 40px;
`;

export { ButtonGroup, OnboardingWrapper, RocketBody };
